// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-view-schedule-container {
  background: white;
  min-height: 100vh;
  font-family: 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  color: #1f2937;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 1900px;
  margin: 20px auto;
}

.v-view-schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px 16px;
  flex-wrap: wrap;
  gap: 16px;
}

.v-header-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.v-week-switcher {
  display: flex;
  gap: 4px;
  background: rgba(0, 47, 167, 0.1);
  border-radius: 12px;
  padding: 4px;
}

.v-week-btn {
  padding: 8px 16px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
  min-width: 130px;
}

.v-week-btn.active {
  background: white;
  color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);
}

.v-refresh-button {
  background: none;
  border: 1px solid #ddd;
  font-size: 1.2em;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.v-refresh-button:hover {
  background-color: #f8f9fa;
  transform: scale(1.05);
}

.v-refresh-icon {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.v-refresh-button:hover .v-refresh-icon {
  transform: rotate(180deg);
}

/* основное содержание */
.v-schedule-main-content {
  padding: 0 32px 32px;
}

.v-day-section {
  margin-bottom: 24px;
}

.v-day-header {
  padding: 16px 0 12px 4px;
}

.v-day-name {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #002FA7;
}

/* карточки пар */
.v-lesson-row,
.v-separated-lesson-row {
  background: white;
  border-radius: 12px;
  padding: 14px 18px;
  margin-bottom: 8px;
  border: 1px solid rgba(0, 47, 167, 0.25);
  transition: all 0.3s ease;
}

.v-lesson-row:hover,
.v-separated-lesson-row:hover {
  background: rgba(0, 47, 167, 0.04);
}

.v-lesson-row.replacement,
.v-separated-lesson-item.replacement {
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  border-radius: 12px;
  padding-left: 10px;
}

.v-lesson-time,
.v-separated-time {
  display: inline-block;
  background: #002FA7;
  color: white;
  padding: 5px 11px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
}

.v-lesson-subject,
.separated-subject {
  font-weight: 600;
  color: #2d3748;
  font-size: 15px;
  margin-bottom: 6px;
  line-height: 1.4;
}

.v-lesson-meta,
.separated-lesson-meta {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.v-lesson-teacher,
.v-lesson-room,
.v-lesson-subgroup,
.separated-teacher-room,
.separated-room,
.separated-subgroup {
  font-size: 13.5px;
}

.v-lesson-room,
.separated-room {
  color: #718096;
}

.v-lesson-subgroup,
.separated-subgroup {
  color: #059669;
}

.v-separated-lesson-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.v-separated-lesson-item {
  padding: 12px 0 0 0;
  border-top: 1px solid rgba(0, 47, 167, 0.1);
}

.v-separated-lesson-item:first-child {
  padding-top: 0;
  border-top: none;
}

/* нет занятий */
.v-no-lessons {
  background: rgba(0, 47, 167, 0.05);
  border-radius: 12px;
  padding: 32px 20px;
  text-align: center;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.v-no-lessons-text {
  color: #718096;
  font-size: 15px;
  font-weight: 500;
  margin: 0;
}

/* пустое расписание */
.v-empty-schedule {
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 12px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.v-empty-schedule h3 {
  color: #64748b;
  margin: 0 0 10px 0;
  font-size: 20px;
}

/* загрузка и ошибка */
.v-view-schedule-loading,
.v-view-schedule-error {
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 12px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.v-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(0, 47, 167, 0.1);
  border-left-color: #002FA7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/md-components/ViewScheduleSection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gIAAgI;EAChI,cAAc;EACd,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;EAC1B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".v-view-schedule-container {\n  background: white;\n  min-height: 100vh;\n  font-family: 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  color: #1f2937;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 1900px;\n  margin: 20px auto;\n}\n\n.v-view-schedule-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px 16px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.v-header-controls {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.v-week-switcher {\n  display: flex;\n  gap: 4px;\n  background: rgba(0, 47, 167, 0.1);\n  border-radius: 12px;\n  padding: 4px;\n}\n\n.v-week-btn {\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n  min-width: 130px;\n}\n\n.v-week-btn.active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);\n}\n\n.v-refresh-button {\n  background: none;\n  border: 1px solid #ddd;\n  font-size: 1.2em;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 6px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n}\n\n.v-refresh-button:hover {\n  background-color: #f8f9fa;\n  transform: scale(1.05);\n}\n\n.v-refresh-icon {\n  width: 20px;\n  height: 20px;\n  transition: transform 0.3s ease;\n}\n\n.v-refresh-button:hover .v-refresh-icon {\n  transform: rotate(180deg);\n}\n\n/* основное содержание */\n.v-schedule-main-content {\n  padding: 0 32px 32px;\n}\n\n.v-day-section {\n  margin-bottom: 24px;\n}\n\n.v-day-header {\n  padding: 16px 0 12px 4px;\n}\n\n.v-day-name {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  color: #002FA7;\n}\n\n/* карточки пар */\n.v-lesson-row,\n.v-separated-lesson-row {\n  background: white;\n  border-radius: 12px;\n  padding: 14px 18px;\n  margin-bottom: 8px;\n  border: 1px solid rgba(0, 47, 167, 0.25);\n  transition: all 0.3s ease;\n}\n\n.v-lesson-row:hover,\n.v-separated-lesson-row:hover {\n  background: rgba(0, 47, 167, 0.04);\n}\n\n.v-lesson-row.replacement,\n.v-separated-lesson-item.replacement {\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  border-radius: 12px;\n  padding-left: 10px;\n}\n\n.v-lesson-time,\n.v-separated-time {\n  display: inline-block;\n  background: #002FA7;\n  color: white;\n  padding: 5px 11px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.v-lesson-subject,\n.separated-subject {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 15px;\n  margin-bottom: 6px;\n  line-height: 1.4;\n}\n\n.v-lesson-meta,\n.separated-lesson-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.v-lesson-teacher,\n.v-lesson-room,\n.v-lesson-subgroup,\n.separated-teacher-room,\n.separated-room,\n.separated-subgroup {\n  font-size: 13.5px;\n}\n\n.v-lesson-room,\n.separated-room {\n  color: #718096;\n}\n\n.v-lesson-subgroup,\n.separated-subgroup {\n  color: #059669;\n}\n\n.v-separated-lesson-content {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.v-separated-lesson-item {\n  padding: 12px 0 0 0;\n  border-top: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.v-separated-lesson-item:first-child {\n  padding-top: 0;\n  border-top: none;\n}\n\n/* нет занятий */\n.v-no-lessons {\n  background: rgba(0, 47, 167, 0.05);\n  border-radius: 12px;\n  padding: 32px 20px;\n  text-align: center;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.v-no-lessons-text {\n  color: #718096;\n  font-size: 15px;\n  font-weight: 500;\n  margin: 0;\n}\n\n/* пустое расписание */\n.v-empty-schedule {\n  text-align: center;\n  padding: 80px 20px;\n  background: white;\n  border-radius: 12px;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.v-empty-schedule h3 {\n  color: #64748b;\n  margin: 0 0 10px 0;\n  font-size: 20px;\n}\n\n/* загрузка и ошибка */\n.v-view-schedule-loading,\n.v-view-schedule-error {\n  text-align: center;\n  padding: 80px 20px;\n  background: white;\n  border-radius: 12px;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.v-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(0, 47, 167, 0.1);\n  border-left-color: #002FA7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 20px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
